<template>
    <div class="row pl-3 pr-3 pb-3 pt-0 mt-0">
        <div class="col-12 mb-3">
            <u><h5 class="font-weight-bold">Datos del menor</h5></u>
        </div>
        <div class="col-12">
            <FormInput label="Nombre" type="text" name="nombre" id="nombre" rules="required" v-model="base.nombre" />
        </div>
        <div class="col-12">
            <FormInput label="Apellidos" type="text" name="apellidos" id="apellidos" rules="required" v-model="base.apellidos" />
        </div>
        <div class="col-12">
            <FormInput label="DNI" type="text" name="dni" id="dni" rules="required" v-model="base.dni" />
        </div>
        <div class="col-12">
            <FormInput label="Fecha de nacimiento" type="datetime" name="fecha_nacimiento" id="fecha_nacimiento" rules="required" v-model="base.fecha_de_nacimiento" />
        </div>
        <div class="col-12">
            <FormInput label="Fecha de caducidad del DNI" type="datetime" name="fecha_caducidad_dni" id="fecha_caducidad_dni" rules="required" v-model="base.fecha_de_caducidad_dni" />
        </div>
        <div class="col-12">
            <FormInput label="Teléfono" type="text" name="telefono" id="telefono" rules="required" v-model="base.telefono" />
        </div>
        <div class="col-12">
            <FormInput label="Email" type="email" name="email" id="email" rules="required" v-model="base.email" />
        </div>
        <div class="col-12">
            <FormInput label="Pais de nacimiento" type="text" name="pais_nacimiento" id="pais_nacimiento" rules="required" v-model="base.pais_de_nacimiento" />
        </div>
        <div class="col-12">
            <FormInput label="Provincia de nacimiento" type="text" name="provincia_nacimiento" id="provincia_nacimiento" rules="required" v-model="base.provincia_de_nacimiento" />
        </div>
        <div class="col-12">
            <FormInput label="Localidad de nacimiento" type="text" name="localidad_nacimiento" id="localidad_nacimiento" rules="required" v-model="base.localidad_de_nacimiento" />
        </div>
        <div class="col-12">
            <FormInput label="Nacionalidad" type="text" name="nacionalidad" id="nacionalidad" rules="required" v-model="base.nacionalidad" />
        </div>
        <div class="col-12">
            <FormInput label="Dirección" type="text" name="direccion" id="direccion" rules="required" v-model="base.direccion" />
        </div>
        <div class="col-12">
            <label>LATERALIDAD</label>
            <ValidationProvider name="lateralidad" id="lateralidad" rules="required" v-slot="{ errors }">
                <multiselect 
                    v-model="base.lateralidad"
                    id="lateralidad"
                    placeholder="Lateralidad"
                    :class="'col-12 mb-3 p-0' + (errors[0] ? 'is-invalid' : '')"
                    style="width: 100%;"
                    :multiple="false" 
                    :options="lateralidades">
                </multiselect>
                <span v-if="errors[0]" class="invalid-feedback mb-4 text-xs" style="width: 98%; display: block; background-color: red; color: white; padding: 2px;">{{ errors[0] }}</span>
            </ValidationProvider>
        </div>
        <div class="col-12" v-if="equipos">
            <label>EQUIPO</label>
            <ValidationProvider name="equipo" id="equipo" rules="required" v-slot="{ errors }">
                <multiselect 
                    v-model="base.equipo"
                    id="equipo"
                    placeholder="Equipo"
                    :class="'col-12 mb-3 p-0' + (errors[0] ? 'is-invalid' : '')"
                    style="width: 100%;"
                    :multiple="false" 
                    :options="equipos"
                    label="nombre"
                    track-by="id">
                </multiselect>
                <span v-if="errors[0]" class="invalid-feedback mb-4 text-xs" style="width: 98%; display: block; background-color: red; color: white; padding: 2px;">{{ errors[0] }}</span>
            </ValidationProvider>
        </div>
        <div class="col-12">
            <FormInput label="Club de procedencia" type="text" name="club_procedencia" id="club_procedencia" rules="" v-model="base.club_de_procedencia" />
        </div>
        <div class="col-12">
            <FormInput label="Observaciones" type="textarea" name="observaciones" id="observaciones" rules="" v-model="base.observaciones" />
        </div>
    </div>
</template>

<script>
export default {
    props: ['base'],
    data() {
        return {
            lateralidades: ['Diestro', 'Zurdo', 'Ambidiestro'],
            equipos: null
        }
    },
    methods: {
        getEquipos() {
            var params = {
                lista_id: this.lista_id,
                filters: {}
            };

            this.$store.dispatch(this.config.getVuexAlias("back.bases.equipos.index"), params).then(res => {
                this.equipos = res.data.data;
            });
        }
    },
    computed: {
        lista_id() {
            return this.$route.params.lista_id;
        }
    },
    created() {
        this.getEquipos();
    }
}

</script>